import { ProgressBarSkeleton } from './progress-bar-skeleton';

import styles from './progress-bar.module.scss';

export interface ProgressBarProps {
	totalSlotSeconds: number;
	plannedSeconds: number;
	reservedSeconds: number;
	availableSeconds: number;
	className?: string;
}

export function ProgressBar({
	totalSlotSeconds,
	plannedSeconds,
	reservedSeconds,
	availableSeconds,
	className
}: ProgressBarProps): JSX.Element | null {
	if (totalSlotSeconds <= 0) {
		return <ProgressBarSkeleton className={className} />;
	}

	const usedSum = plannedSeconds + reservedSeconds + availableSeconds;

	if (usedSum > totalSlotSeconds) {
		console.error('ProgressBar: segment sum exceeds totalSlotSeconds', {
			totalSlotSeconds,
			plannedSeconds,
			reservedSeconds,
			availableSeconds
		});
		return null;
	}

	const toPercent = (value: number) => `${(value / totalSlotSeconds) * 100}%`;
	const remainingTime = totalSlotSeconds - usedSum;

	const rootClassName = [styles.track, className].filter(Boolean).join(' ');

	return (
		<div className={rootClassName} data-test-id="progress-bar-multi-segments">
			<div
				data-testid="progress-bar-segment-utilized"
				className={`${styles.segment} ${styles.utilized}`}
				style={{ width: toPercent(plannedSeconds) }}
			/>
			<div
				data-testid="progress-bar-segment-reserved"
				className={`${styles.segment} ${styles.reserved}`}
				style={{ width: toPercent(reservedSeconds) }}
			/>
			<div
				data-testid="progress-bar-segment-available"
				className={`${styles.segment} ${styles.available}`}
				style={{ width: toPercent(availableSeconds) }}
			/>
			<div
				data-testid="progress-bar-segment-remaining"
				className={`${styles.segment} ${styles.remaining}`}
				style={{ width: toPercent(remainingTime) }}
			/>
		</div>
	);
}

export default ProgressBar;
